import IMAGES from '@/const/images';
import { Image } from 'antd';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

const Logo: FC = () => {
    const navigate = useNavigate();
    const styles = {
        logo: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '12px 0',
            margin: '0 auto',
            width: '100%',
        },
    };

    return (
        <div style={styles.logo}>
            <Image
                src={IMAGES.logo.horizontal}
                alt="logo-picker"
                preview={false}
                onClick={() => navigate('/')}
                width="80%"
            />
        </div>
    );
};

export { Logo };
